import { render } from "./AboutText.vue?vue&type=template&id=69013bf0"
import script from "./AboutText.vue?vue&type=script&lang=js"
export * from "./AboutText.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__